import React, { useEffect, useState } from 'react';
import { Titled } from 'react-titled';
import { useTranslation } from 'react-i18next';
import AppLayout from 'components/common/AppLayout';
import NoticeLayoutRedesign from 'components/common/NoticeLayoutRedesign';
import { Box, Button, Flex, Spinner, Text } from '@resideo/blueprint-react';
import styled from 'styled-components';
import useTokenClaims from 'hooks/useTokenClaims';
import PageLoading from 'components/common/PageLoading';
import { PRO_PORTAL_URL } from 'config';

const NextButton = styled(Button)`
  width: 325px;

  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    width: 262px;
  }
`;

const CompanyInfoLanding = () => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const isRequestJoin = new URLSearchParams(location.search).get(
    'requestToJoin'
  );
  const { isLoading, returnToUrl } = useTokenClaims();

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      localStorage.setItem('cameFrom', 'proPortal');
      window.location.replace(PRO_PORTAL_URL);
    };

    window.onpopstate = handlePopState;
  }, []);

  const handleSubmit = () => {
    setSubmitting(true);

    window.location.href = returnToUrl ?? PRO_PORTAL_URL;
  };

  if (isLoading) {
    return <PageLoading />;
  }

  return (
    <Titled title={title => `${t('signUp.companyInfo.header')} - ${title}`}>
      <AppLayout
        showHeader={false}
        showLeftNav={false}
        showGreyPanel={true}
        showFooter={false}>
        <NoticeLayoutRedesign
          title={
            isRequestJoin
              ? t('signUp.companyInfo.requestedJoin.header')
              : t('signUp.companyInfo.noMatching.header')
          }
          showFooter={false}>
          <Flex flexDirection='column'>
            <Flex flexDirection='column' alignItems='left' padding='large'>
              <Box maxWidth='550px' fontSize='18px'>
                <Text
                  lineHeight='1.25'
                  marginBottom='large'
                  data-test-company-info-landing-subheader1>
                  {isRequestJoin
                    ? t('signUp.companyInfo.requestedJoin.subHeader1')
                    : t('signUp.companyInfo.noMatching.subHeader1')}
                </Text>
                <Text
                  textAlign='left'
                  lineHeight='1.25'
                  data-test-company-info-landing-subheader2>
                  {t('signUp.companyInfo.meanwhile')}
                </Text>
              </Box>
            </Flex>
            <Box>
              <Flex paddingBottom='xLarge' justifyContent='center'>
                <NextButton
                  className='common-button primary'
                  variant='primary'
                  type='submit'
                  onClick={handleSubmit}
                  data-test-submit-button>
                  {submitting && (
                    <Spinner
                      aria-label={t('common.saving')}
                      marginX='small'
                      color='white'
                      verticalAlign='text-top'
                    />
                  )}
                  {!submitting && t('common.next')}
                </NextButton>
              </Flex>
            </Box>
          </Flex>
        </NoticeLayoutRedesign>
      </AppLayout>
    </Titled>
  );
};

export default CompanyInfoLanding;
